import React, { useState } from 'react';
import './RezRateSideDrawer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const RezRateSideDrawer = ({ children, isOpen, setIsOpen }) => {
  //   const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`side-drawer ${isOpen ? 'open' : ''}`} style={{ zIndex: 900 }}>
      <div className="drawer-handle" onClick={toggleDrawer}>
        <FontAwesomeIcon icon={isOpen ? faChevronLeft : faChevronRight} />
      </div>
      <div className="drawer-content">{children}</div>
    </div>
  );
};

export default RezRateSideDrawer;
